export enum ContentType {
  Toolkit_Guideline = 'Toolkit_Guideline',
  Template_Form = 'Template_Form',
  Educational_Training = 'Educational_Training',
  Audit_Report = 'Audit_Report',
  Event_Webinar = 'Event_Webinar',
  Publication_Article = 'Publication_Article',
  Landing_Portal = 'Landing_Portal',
  Reference_External = 'Reference_External',
}

export enum Audience {
  Nurses = 'Nurses',
  Physicians = 'Physicians',
  Transfusionists = 'Transfusionists',
  Laboratory = 'Laboratory',
  Administrators = 'Administrators',
  QualitySafety = 'QualitySafety',
  Educators = 'Educators',
  StudentsTrainees = 'StudentsTrainees',
  DataAnalytics = 'DataAnalytics',
  PolicyRegulators = 'PolicyRegulators',
  ProcurementInventory = 'ProcurementInventory',
  PatientsCaregivers = 'PatientsCaregivers',
  Other = 'Other',
  Unknown = 'Unknown',
}

export enum ClinicalArea {
  TransfusionMedicine = 'TransfusionMedicine',
  Hematology = 'Hematology',
  Neurology = 'Neurology',
  Rheumatology = 'Rheumatology',
  Anesthesiology = 'Anesthesiology',
  Obstetrics = 'Obstetrics',
  PediatricsNeonatology = 'PediatricsNeonatology',
  Emergency = 'Emergency',
  ICUCriticalCare = 'ICUCriticalCare',
  SurgeryPerioperative = 'SurgeryPerioperative',
  Oncology = 'Oncology',
  Cardiology = 'Cardiology',
  InternalMedicine = 'InternalMedicine',
  HomeInfusion = 'HomeInfusion',
  PrimaryCare = 'PrimaryCare',
  Dermatology = 'Dermatology',
  Immunology = 'Immunology',
  InfectiousDiseases = 'InfectiousDiseases',
  Transplant = 'Transplant',
  Other = 'Other',
  Unknown = 'Unknown',
}

export enum Topic {
  IVIG = 'IVIG',
  SCIG = 'SCIG',
  IGOrderingOntario = 'IGOrderingOntario',
  Utilization = 'Utilization',
  MHP = 'MHP',
  Shortage = 'Shortage',
  Redistribution = 'Redistribution',
  InventoryManagement = 'InventoryManagement',
  RBC = 'RBC',
  Plasma = 'Plasma',
  ABPlasma = 'ABPlasma',
  Platelets = 'Platelets',
  Cryoprecipitate = 'Cryoprecipitate',
  Albumin = 'Albumin',
  C1EsteraseInhibitors = 'C1EsteraseInhibitors',
  ImmuneSerumGlobulin = 'ImmuneSerumGlobulin',
  Prenatal = 'Prenatal',
  Postnatal = 'Postnatal',
  Neonatal = 'Neonatal',
  FetalGenotyping = 'FetalGenotyping',
  Rounds = 'Rounds',
  BootCamp = 'BootCamp',
  Symposium = 'Symposium',
  Webinar = 'Webinar',
  GHEST = 'GHEST',
  eLearning = 'eLearning',
  TrainingEducation = 'TrainingEducation',
  Guidelines = 'Guidelines',
  Procedures = 'Procedures',
  Templates = 'Templates',
  Forms = 'Forms',
  Checklists = 'Checklists',
  ReferenceManual = 'ReferenceManual',
  Policy = 'Policy',
  Regulation = 'Regulation',
  BloodSafety = 'BloodSafety',
  PublicHealth = 'PublicHealth',
  Research = 'Research',
  Quality = 'Quality',
  Education = 'Education',
  Safety = 'Safety',
  Clinical = 'Clinical',
  Audit = 'Audit',
  ProvincialAuditReport = 'ProvincialAuditReport',
  ORBCoNAnnualReport = 'ORBCoNAnnualReport',
  ValidationVerification = 'ValidationVerification',
  ProspectiveScreening = 'ProspectiveScreening',
  DataDashboard = 'DataDashboard',
  ORBCoNReport = 'ORBCoNReport',
  TransfusionistsTalk = 'TransfusionistsTalk',
  NewsAnnouncement = 'NewsAnnouncement',
  PatientFactSheets = 'PatientFactSheets',
  ExternalLink = 'ExternalLink',
  Other = 'Other',
  Unknown = 'Unknown',
}

export interface ResourceMetadata {
  contentType?: ContentType;
  audiences?: Audience[];
  clinicalAreas?: ClinicalArea[];
  topics?: Topic[];
}

export interface WPPostWithMetadata {
  id: number;
  metadata?: ResourceMetadata;
}

